import { render } from "./S166210.vue?vue&type=template&id=349fd569"
const script = {}
script.render = render

export default script